import React, { useMemo, lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";

import { useTypedSelector } from "../../../../redux/store";
import useActiveTab from "../../../../hooks/useActiveTab";
import { hasAccess } from "../../../../access";
import { TabOptions } from "../../../../types";
import BasicPageLayout from "../../../../components/BasicPageLayout";
import { SuspenseLoader, SideTab } from "../../../../components/common";

import { TabKeys, TabAccessNames } from "./constants/access";

const LazyUsersActivity = lazy<React.FC<SalaryReportsPage.Props>>(async () => {
	const elem = await import(
		"./tabs/UsersActivity" /* webpackChunkName: "reports-salary-reports-page-users-activity" */
	);
	return { default: elem.default };
});

const SalaryReportsPage: React.FC = () => {
	const { t } = useTranslation();

	const personalRole = useTypedSelector(
		(state) => state.account.personalRole,
	);

	const tabs: TabOptions.Array = useMemo(
		() =>
			[
				{
					key: TabKeys.USERS_ACRIVITY,
					label: t("mainPage.reports.salary.usersActivity.title"),
					value: {
						render: () => (
							<Suspense fallback={<SuspenseLoader />}>
								<LazyUsersActivity
									headerTitle={t(
										"mainPage.reports.salary.usersActivity.title",
									)}
								/>
							</Suspense>
						),
					},
					accessName: TabAccessNames[TabKeys.USERS_ACRIVITY],
				},
			].filter((btn) => hasAccess(btn.accessName, personalRole)),
		[t, personalRole],
	);

	const { activeKey, activeTab, setActiveKey } = useActiveTab(tabs);

	return (
		<BasicPageLayout
			navigation={
				<SideTab
					value={activeKey}
					onChange={(newActive) => setActiveKey(newActive)}
					options={tabs}
					variant="vertical"
				/>
			}
			content={activeTab.value.render()}
		/>
	);
};

declare namespace SalaryReportsPage {
	interface Props {
		headerTitle: string;
		general?: boolean;
	}
}

export default SalaryReportsPage;
